module.exports = __webpack_public_path__ + "img/flag_kor.d0de0223.svg";